
/**
 * Handles communication with the Supabase function for form submission
 */
export const submitFormToNetlifyFunction = async (formData: Record<string, any>) => {
  try {
    console.log('Sending data to Supabase function for submission...');
    
    // Log the URL we're sending to
    const functionUrl = 'https://xjlpuyrqxgxnyixqwfml.supabase.co/functions/v1/process-form';
    console.log(`Sending request to: ${functionUrl}`);
    console.log(`Request payload sample:`, {
      formType: formData.formType,
      name: formData.name,
      email: formData.email
    });
    
    // Check for essential form data before submitting
    const requiredFields = ['email'];
    const missingFields = requiredFields.filter(field => !formData[field]);
    
    if (missingFields.length > 0) {
      console.error(`Missing required fields: ${missingFields.join(', ')}`);
      throw new Error(`Form is missing required fields: ${missingFields.join(', ')}`);
    }
    
    // Make the request to Supabase function with CORS mode specified
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(formData),
      mode: 'cors' // Explicitly state we're using CORS
    });

    console.log(`Response status: ${response.status} ${response.statusText}`);
    
    // Check for content-type header to debug issues
    const contentType = response.headers.get('content-type');
    console.log(`Response content-type: ${contentType || 'not specified'}`);

    // Get detailed info for 404 errors
    if (response.status === 404) {
      console.error('Function endpoint returned 404. Function may not be deployed or is incorrectly configured.');
      
      const responseText = await response.text();
      console.error('404 response text:', responseText.substring(0, 200));
      
      throw new Error(`Supabase function not found (404). Check that the function is deployed correctly.`);
    }

    return response;
  } catch (error) {
    console.error('Error sending data to Supabase function:', error);
    
    // Provide more debugging context in the error
    const errorMessage = error instanceof Error ? error.message : String(error);
    const enhancedError = new Error(`API Error: ${errorMessage} | URL: https://xjlpuyrqxgxnyixqwfml.supabase.co/functions/v1/process-form | Browser: ${navigator.userAgent}`);
    
    if (error instanceof Error) {
      enhancedError.stack = error.stack;
    }
    
    throw enhancedError;
  }
};
